export default __webpack_public_path__ + "static/media/1964.d39e734f.png";